import { ApplicationStore } from "src/store";
import { getVehiclesArrayForFEA } from "src/store/selectors/vehicles";
import { getFullName } from "src/store/selectors/person";
import { createSelector } from "reselect";
import { PersistentMessageState } from "src/components/Chat/redux/reducer";
import { getYearMakeModelTrim } from "src/store/selectors/tradeIn";

export const getTranscript = (state: ApplicationStore) => state.messages.transcript;

export const getPastTranscripts = (state: ApplicationStore) => state.messages.pastTranscripts;

export const getMessages = createSelector(getTranscript, getPastTranscripts, (transcript, pastTranscripts) => [
    ...(pastTranscripts ?? []),
    ...(transcript ?? []),
]);

export const getSendingMessages = (state: ApplicationStore) => state.messages.sending;

export const getFailedMessages = (state: ApplicationStore) => state.messages.failed;

export const hasConversationsConfig = (state: ApplicationStore) => !!state.messages.conversations_config;

export const getConversationsConfig = (state: ApplicationStore) => state.messages.conversations_config;

export const getAvatars = (state: ApplicationStore) => state.messages.avatars;

export const getSelectedTeam = (state: ApplicationStore) => state.messages.selectedTeam;

export const isLeavingMessage = (state: ApplicationStore) => state.messages.isLeavingMessage;

export const getSerializedInitialChat = (state: ApplicationStore) => {
    const vehicles = getVehiclesArrayForFEA(state).map(
        (vehicle) => `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} (${vehicle.vin})`
    );
    const vehicleString = vehicles.join(", ");
    const ymmt = getYearMakeModelTrim(state);

    if (!ymmt) {
        return `${getFullName(state)}'s Online Shopper Garage has ${vehicles.length} ${
            vehicles.length < 2 ? "vehicle" : "vehicles"
        }: ${vehicleString}. They have not provided their trade in information yet. They would like to chat!`;
    }

    return `${getFullName(state)}'s Online Shopper Garage has ${vehicles.length} ${
        vehicles.length < 2 ? "vehicle" : "vehicles"
    }: ${vehicleString}. They are trading in a ${ymmt} with ${state.tradeIn.odometer?.amount}${
        state.tradeIn.odometer?.unit
    }. They would like to chat!`;
};

export const getChatStateToPersist = createSelector(
    getPastTranscripts,
    getConversationsConfig,
    getAvatars,
    getSelectedTeam,
    (pastTranscripts, conversations_config, avatars, selectedTeam): PersistentMessageState => ({
        pastTranscripts,
        conversations_config,
        avatars,
        selectedTeam,
    })
);
